import React, { useState } from 'react';
import { updatePassword , userLogout ,AccessRefreshToken} from "../../../Redux/actions/user";
import { addNotification } from "../../../Utilities/notifications";
import axios from "axios";

function ResetPassword (props) {  
    let state = {
        newPassword:"",
        confirmPassword:"",
        currentPassword:"",
        errors:{
            newPassword:"",
            confirmPassword:"",
            currentPassword:""
        }       
    }
    
    let [obj, setObj] = useState(state);
    const [loading, setLoading] = useState(false);

    const handleSubmit =async (e) =>{
        e.preventDefault(); 
        let { errors ,currentPassword } = obj
        let currentPassStatus=await AccessRefreshToken(props.user.email,currentPassword);
        if(currentPassStatus.status==200){
            if( validation(errors)){
                let payload={
                    "type": "password", 
                    "temporary": false, 
                    "value": obj.newPassword 
                }
                let data = await updatePassword(props.user,payload);      
                if(data.status==204){
                    addNotification({
                        title: "Techforce.ai",
                        message: "Password has been updated Successfully",
                        type: "success"
                    });
                    props.toggle()
                    await userLogout(props.user.sub);      
                    props.handleLogout();
                }
            }
        }else{

            if(currentPassStatus.status==401){
                addNotification({
                    title: "Techforce.ai",
                    message: currentPassStatus.message,
                    type: "warning"
                });
            }
        }
        
    }

    const handleChange = (e) => {
        obj = { ...obj, [e.target.name]: e.target.value }
        let {name,value} = e.target        
        let { errors } = obj
        switch(name){
          case 'newPassword':
            let pattern=/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/
            errors.newPassword = value && !pattern.test(value) ?
            "Please enter password with min 6 charecters.":""
            break;
          case 'confirmPassword':
            errors.confirmPassword = value && obj.newPassword!==value ?
            "Password didn't match.":""
            break;
            default:
        }
        setObj({ ...obj , errors});
    }

    const keyPress = async(e) => {
        if (e.key === 'Enter' ){
          e.preventDefault()      
        }
      }

    const validation = (errors)=>{        
        let valid = true;
        Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
        );        
        return valid;
    }

    return(
        <div>
            <form className="form-container" onSubmit={handleSubmit} onKeyPress={keyPress}>
                <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Current Password</label>
                    <input type="text" className="form-control-1" name="currentPassword"  onChange={handleChange} value={obj.currentPassword} placeholder="Enter" required></input>
                    <i  style={{ color: "black",cursor:"pointer",paddingTop:"5px",float:"right",fontFamily:"Roboto"}}
                        data-toggle="tooltip" data-placement="top" title="Password that contains minimum 6 characters including numbers 
                        and uppercase , lowercase letters and special characters"
                        >Password Policy <i class="fa fa-info-circle" style={{ color: "rgb(188, 180, 180)"}}></i>
                    </i>
                    {obj.errors.currentPassword.length > 0 && 
                    <span className='error'>{obj.errors.currentPassword}</span>}
                </div>
                <div className="form-group">
                    <label htmlFor="exampleInputEmail1">New Password</label>
                    <input type="text" className="form-control-1" name="newPassword"  onChange={handleChange} value={obj.newPassword} placeholder="Enter" required></input>
                    <i  style={{ color: "black",cursor:"pointer",paddingTop:"5px",float:"right",fontFamily:"Roboto"}}
                        data-toggle="tooltip" data-placement="top" title="Password that contains minimum 6 characters including numbers 
                        and uppercase , lowercase letters and special characters"
                        >Password Policy <i class="fa fa-info-circle" style={{ color: "rgb(188, 180, 180)"}}></i>
                    </i>
                    {obj.errors.newPassword.length > 0 && 
                    <span className='error'>{obj.errors.newPassword}</span>}
                </div>
                <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Confirm Password</label>
                    <input type="text" className="form-control-1" name="confirmPassword" onChange={handleChange} value={obj.confirmPassword} placeholder="Enter" required></input>
                    {obj.errors.confirmPassword.length > 0 && 
                    <span className='error'>{obj.errors.confirmPassword}</span>}
                </div>
                <div className="text">
                    <button className="button"  onClick={()=>props.toggle()}>
                                Cancel
                    </button>
                    <button className="btn" type="submit" onClick={handleSubmit} >{loading ? <i
                    style={{ fontSize: "15px", color: "#ffffff"}}
                    className="fas fa-circle-notch fa-spin"
                    ></i> : "Submit" }</button>
                </div>
            </form>
        </div>
    )
}
export default ResetPassword;